import { Card, Col, Container, Form, Row } from 'components/ui';
import useRefreshToken from 'hooks/useRefreshToken.js';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const FormStyle = styled(Form)`
	width: '100%';
	align-items: 'center';
`;

const Step12 = (props) => {
	const [t] = useTranslation(['translation']);
	useRefreshToken();
	return (
		<>
			<form
				className={FormStyle}
				onSubmit={(e) => {
					e.preventDefault();
					props.next();
				}}
			>
				<Container spacing={4}>
					<Row
						xs={12}
						style={{
							// height: 'auto',
							textAlign: 'bottom',
						}}
					>
						<Col xs={12}>
							<Card.Title>
								{t('impfschaeden.erfassen.danke_daten_sind_eingegangen')}
								<br />
								<br />
								{t('impfschaeden.erfassen.wie_weiter')}
							</Card.Title>
							<p>
								<br />
								{props.confirmed &&
									t('impfschaeden.erfassen.bitte_email_verifizieren')}
								{!props.confirmed &&
									t(
										'impfschaeden.erfassen.manuelles_pruefen_der_daten_alternativ'
									)}
								<br />
								{props.confirmed &&
									t('impfschaeden.erfassen.manuelles_pruefen_der_daten')}
								<br />
								<br />
								<br />
								<br />
								<br />
								<br />
								{t('impfschaeden.erfassen.marketing')}
							</p>
						</Col>
					</Row>
				</Container>
			</form>
		</>
	);
};

Step12.propTypes = {
	next: PropTypes.func,
	confirmed: PropTypes.bool,
};

export default Step12;
